import axios from 'axios';
import { editRouteQuery } from './queries';
import { buildExpressQuery, buildLoopbackQuery } from './queries/builders';
import Split from '../split';

const editTrailer = (model, key) =>
    new Promise((resolve, reject) => {
        const useExpress = Split.getBooleanTreatment('use_express_migration_endpoints');
        const queryBuilder = useExpress ? buildExpressQuery : buildLoopbackQuery;
        const query = editRouteQuery({ key, model, queryBuilder });
        const request = axios.patch(query.url, { ...query.body });

        request
            .then((response) => {
                resolve({ data: response.data });
            })
            .catch((errors) => {
                // eslint-disable-next-line no-console
                console.log(errors);
                reject(new Error('Unable to edit route'));
            });
    });

export default editTrailer;
